var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 0.666687H1.03333C0.978798 0.670894 0.927879 0.695565 0.890784 0.735751C0.853689 0.775937 0.833164 0.828664 0.833326 0.883354V1.60002C0.832825 1.67348 0.846934 1.7463 0.874831 1.81425C0.902728 1.88221 0.943857 1.94394 0.995826 1.99585L5.99583 6.99585V11.1625L9.01666 12.6667V6.98752L14.0167 1.98752C14.1123 1.88434 14.1658 1.74905 14.1667 1.60835V0.883354C14.1667 0.82589 14.1438 0.77078 14.1032 0.730147C14.0626 0.689514 14.0075 0.666687 13.95 0.666687Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2cd5d5526d095f0209a1658c8ead850a.svg";
export { ForwardRef as ReactComponent };